import React, { useState, useEffect } from 'react' 
import { useNavigate, Link } from 'react-router-dom';

import axios from "axios";
import * as Yup from "yup";
import { useFormik} from "formik";
import swal from "sweetalert";


export default function FaqAdd() {
    const [questionError , setQuestionError] = useState('')
    const [answereError , setAnswereError] = useState('')

    const validationSchema = Yup.object().shape({
        question: Yup.string().required("Question is required.")
        .min(5, "Question must be at least 5 characters.")
        .max(250, "Question can not be exceed 250 characters."),
        answere: Yup.string().required("Answere is required.")
        .min(5, "Answere must be at least 5 characters.")
    });

    const formik = useFormik({
        initialValues: {
            question: "",
            answere: ""
        },
        validationSchema,
        onSubmit: async (data, {setErrors}) => {
            console.log("data ===> ", data)
            await axios.post(process.env.REACT_APP_API_KEY + "api/admin/faq-add", data, {
                headers: {
                "Content-type": "Application/json",
                "Authorization": localStorage.getItem("token")
                }   
            })
            .then((res) => {
                console.log("response ===> ", res)
                //Check for Authorized
                if(res.data.code == 403){
                  localStorage.clear();
                  nav('/admin/login');
                }
      
                if (res.status === 200) {
                  swal({
                    title: "Wow!",
                    text: "FAQ added successfully!",
                    icon: "success",
                    button: "Okay",
                  })

                  console.log(res.data)
                  nav("/admin/faq-list")
                  
                } 
              })
              .catch(error => {
                console.log("error ==> ", error)

                if (!error.response.data.status) {
                    const resdata = error.response.data.errors;
                    console.log(resdata);
                    Object.keys(resdata).forEach(function(key) {
                      if(key == 'question'){
                        setQuestionError(resdata[key]);
                      }
                      if(key == 'answere'){
                        setAnswereError(resdata[key]);
                      }
                      console.log('Key : ' + key + ', Value : ' + resdata[key])
                    })
                  } else {
                    swal("Oops", "Unauthorized User", "error");
                  }
              })

        }

    });


const nav = useNavigate();
  const config = {
    headers: { 
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
      }
  };

  return (
    <div className="wrapper">   
        <div className="content-wrapper">
            <form  className="mx-5 col-md-5 faq-form-admin" onSubmit={formik.handleSubmit}>
                <h2>Add New FAQ</h2>
                <div className="ui form box-body">
                    <div className="field form-group">               
                        <label>Question</label>
                        <input
                        type="text"
                        name="question"
                        autoComplete="nope"
                        placeholder="Question"             
                        className="form-control" 
                        onChange={formik.handleChange}
                        value={formik.values.question}
                        />
                    </div>
                    <div className="text-danger error-msg">
                        {formik.errors.question || questionError ? formik.errors.question || questionError : null}
                    </div>

                <div className="field form-group">               
                    <label>Answere</label>
                    <textarea
                        name="answere"
                        autoComplete="nope"
                        placeholder="Answere"             
                        className="form-control"
                        rows="8"
                        onChange={formik.handleChange}
                        value={formik.values.answere} >
                    </textarea>
                </div>
                <div className="text-danger error-msg">
                    {formik.errors.answere || answereError ? formik.errors.answere || answereError : null}
                </div>

                <div className='btn-allign'>
                    <button type="submit" className="btn btn-danger submit-btn">Add</button>
                    <Link to="/admin/faq-list"><button className="btn btn-primary submit-btn">Back</button></Link>
                </div>
            </div>
        </form>
    </div>      
</div>
  )
}